import Common from "../../../Common";
import { FileType } from "../../../Enums";

const Member = class extends Common {
	async search(
		options: {
			'queues[]': any,
			datetime_from?: string,
			datetime_to?: string,
			limit?: number,
			responseType?: string,
		}
	) {
		return this.get(`/queue/cdr/member`, options);
	}

	async download(
		type: FileType,
		options?: {
			'queues[]': any,
			datetime_from?: string,
			datetime_to?: string,
			limit?: number,
			responseType?: string,
		}
	) {
		return this.get(
			`/queue/cdr/member/download/${type}`,
			options,
			{ responseType: options?.responseType ?? 'blob' }
		);
	}
}

export default Member;
